module.exports = __webpack_public_path__ + "static/media/disinfectionIcon.c8856425.svg";